import { atom, RecoilState } from "recoil";

import { sessionStorageRecoilSync } from "@core/data/session-storage-repository";

export const preContractNotifiedState: RecoilState<boolean> = atom({
  key: "preContractNotified",
  default: false,
  effects: [sessionStorageRecoilSync("preContractNotified")],
});
